import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { getHighLevelContext } from '@/utils/highlevel';

interface UseSyncStatusPollingOptions {
  /** Only poll when both CRM and Xero are connected */
  enabled?: boolean;
}

export function useSyncStatusPolling(options: UseSyncStatusPollingOptions = {}) {
  const context = getHighLevelContext();
  const locationId = context?.locationId || '';
  const { enabled = true } = options;

  const {
    data: syncStatus,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['sync-status', locationId],
    queryFn: () => apiClient.getSyncStatus(locationId),
    // Only poll when locationId exists AND enabled is true (both connections established)
    enabled: !!locationId && enabled,
    refetchInterval: enabled ? 5000 : false, // Only poll when enabled
    staleTime: 4000, // Consider data stale after 4 seconds
  });

  return {
    syncStatus,
    isLoading,
    error,
  };
}
